module.exports = __webpack_public_path__ + "images/bug_wine_red_large_4cbdc5a589460cb991345c45454bf526.png";